import React from 'react';
import { IPage } from 'layouts/Navbar/Navbar.types';
import NavbarLink from 'layouts/Navbar/NavbarLink';

import { Box } from '@mui/material';

interface NavbarLinksProps {
  pages: IPage[];
}

const NavbarLinks: React.FunctionComponent<NavbarLinksProps> = ({ pages }) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.box}>
        {pages.map((page) => (
          <NavbarLink key={page.path} page={page} />
        ))}
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    marginLeft: 'auto',
  },
  box: {
    flexGrow: 1,
    display: { xs: 'none', md: 'flex' },
  },
};

export default NavbarLinks;
